import { render } from "./QueryCard.vue?vue&type=template&id=0b2deb11&scoped=true&ts=true"
import script from "./QueryCard.vue?vue&type=script&lang=ts"
export * from "./QueryCard.vue?vue&type=script&lang=ts"

import "./QueryCard.vue?vue&type=style&index=0&id=0b2deb11&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2deb11"]])

export default __exports__